import * as React from 'react';

import StyledTextIcon from './TextIcon.style';

interface TextIconProps {
  label: string;
  disabled?: boolean;
}

const TextIcon: React.FC<TextIconProps> = ({ label, disabled }) => {
  return (
    <StyledTextIcon disabled={disabled}>
      {label
        .split(' ')
        .map(x => x[0])
        .slice(0, 2)}
    </StyledTextIcon>
  );
};

export default TextIcon;
